import { Grid, Typography } from "@mui/material"
import Header from "components/Header/Header"
import { createBreadcrumbs } from "helpers/breadCrumbs"
import React, { useEffect, useState, useCallback } from "react"
import styles from "./Quiz.module.scss"
import ContestTable from "./components/ContestTable"
import { getWeeklyQuizAction } from "redux/marketing/actions"
import { useDispatch, useSelector } from "react-redux"
import { getMonthWithOffset } from "helpers/functions"
import {
  getLastWeeklyQuizAction,
  getNextWeeklyQuizAction,
  getPreviousToLastWeeklyQuizAction,
  setupWeeklyQuizzesAction
} from "redux/marketing/actions/user"
import AppButton from "components/StyledComponents/AppButton"
import GenerateQuizModal from "./components/GenerateQuizModal"

const WeeklyQuiz = () => {
  const [breadcrumbs, setBreadcrumbs] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { weeklyQuizList, nextWeeklyQuizList, lastWeeklyQuizList, previousToLastWeeklyQuizList } =
    useSelector((state) => state.marketing)
  const { isLoading } = useSelector((state) => state.app)
  const dispatch = useDispatch()

  const handleGenerateQuiz = () => {
    setIsModalOpen(true)
  }

  const handleModalClose = () => {
    setIsModalOpen(false)
  }

  const refetchQuizLists = useCallback(() => {
    const nextMonth = getMonthWithOffset(1)
    const currentMonth = getMonthWithOffset(0)
    const lastMonth = getMonthWithOffset(-1)
    const previousToLastMonth = getMonthWithOffset(-2)

    dispatch(getWeeklyQuizAction({ month: currentMonth }))
    dispatch(getNextWeeklyQuizAction({ month: nextMonth }))
    dispatch(getLastWeeklyQuizAction({ month: lastMonth }))
    dispatch(getPreviousToLastWeeklyQuizAction({ month: previousToLastMonth }))
  }, [])

  const handleModalSubmit = (payload) => {
    dispatch(
      setupWeeklyQuizzesAction({
        ...payload,
        onSuccess: refetchQuizLists
      })
    )
    setIsModalOpen(false)
  }

  useEffect(() => {
    document.title = "Weekly Quiz"
    setBreadcrumbs(createBreadcrumbs())
    refetchQuizLists()
  }, [refetchQuizLists])

  return (
    <Grid Container>
      <Grid item xs={12}>
        <Header title="Weekly Quiz" breadCrumbs={breadcrumbs}>
          <AppButton className={styles.generateQuizBtn} onClick={handleGenerateQuiz}>
            Generate Quiz
          </AppButton>
        </Header>
      </Grid>
      <Grid item>
        {weeklyQuizList?.length ? (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography className={styles.heading} variant="h2">
                {new Date(new Date().setMonth(new Date().getMonth() + 1)).toLocaleString(
                  "default",
                  {
                    month: "long",
                    year: "numeric"
                  }
                )}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <ContestTable weeklyQuizList={nextWeeklyQuizList} isLoading={isLoading} />
            </Grid>
          </Grid>
        ) : null}

        <Grid container spacing={2} mt={2}>
          <Grid item xs={12}>
            <Typography className={styles.heading} variant="h2">
              {new Date().toLocaleString("default", { month: "long", year: "numeric" })}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <ContestTable weeklyQuizList={weeklyQuizList} isLoading={isLoading} />
          </Grid>
        </Grid>

        <Grid container spacing={2} mt={2}>
          <Grid item xs={12}>
            <Typography className={styles.heading} variant="h2">
              {new Date(new Date().getFullYear(), new Date().getMonth() - 1).toLocaleString(
                "default",
                {
                  month: "long",
                  year: "numeric"
                }
              )}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <ContestTable weeklyQuizList={lastWeeklyQuizList} isLoading={isLoading} />
          </Grid>
        </Grid>

        <Grid container spacing={2} mt={2}>
          <Grid item xs={12}>
            <Typography className={styles.heading} variant="h2">
              {new Date(new Date().setMonth(new Date().getMonth() - 2)).toLocaleString("default", {
                month: "long",
                year: "numeric"
              })}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <ContestTable weeklyQuizList={previousToLastWeeklyQuizList} isLoading={isLoading} />
          </Grid>
        </Grid>
      </Grid>
      <GenerateQuizModal
        open={isModalOpen}
        onClose={handleModalClose}
        onSubmit={handleModalSubmit}
        isLoading={isLoading}
      />
    </Grid>
  )
}

export default WeeklyQuiz
